var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-Sidebar"},[(_vm.show)?_c('div',{staticClass:"t-SidebarBackdrop",on:{"click":_vm.handleClick}}):_vm._e(),_c('transition',{class:_vm.classes,attrs:{"name":"t-Slide"}},[(_vm.show)?_c('div',{staticClass:"t-SidebarPanel",class:_vm.classes},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }